
import {
  Component, PropSync, Mixins, Prop, Watch,
} from 'vue-property-decorator';
import focusMixin from '@/features/common/mixins/focusMixin';
import moment from 'moment';
import InputDatePicker from '@/features/common/components/InputDatePicker.vue';
import InputTimePicker from '@/features/common/components/InputTimePicker.vue';
import { deliveryTimeType, InProgress } from '../../types';
import { getAppointmentDefaultDate, getAppointmentTime } from '../../helpers/createShipment';

@Component({
  components: {
    InputDatePicker,
    InputTimePicker,
  },
})
export default class DeliveryAppointmentModal extends Mixins(focusMixin) {
  @PropSync('show', { required: true }) syncedShow!: boolean;

  @Prop({ required: true }) deliveryTime!: deliveryTimeType | null;

  private isSubmitting = false;

  private appointment = {
    date: getAppointmentDefaultDate(),
    time: getAppointmentTime(),
  }

  get inProgressData(): InProgress {
    return this.$store.getters.getInProgress;
  }

  @Watch('syncedShow')
  private onIsInProgressDataChange(isShow: boolean) {
    if (!isShow) return;
    this.appointment.date = getAppointmentDefaultDate(this.inProgressData.shipDate);
  }

  private async submit() {
    const { toAddress } = this.inProgressData;

    const payload: InProgress = {
      ...this.inProgressData,
      toAddress: {
        ...toAddress,
        appointment: {
          appointmentType: 'Scheduled',
          date: this.appointment.date,
          time: this.appointment.time,
        },
      },
    };

    this.$store.commit('setInProgress', payload);

    this.isSubmitting = true;
    await this.$store.dispatch('syncInProgressData');
    this.isSubmitting = false;
    this.$emit('next');

    this.syncedShow = false;
  }

  private allowedDatePickerDates = (date) => {
    const biggerThanToday = moment(this.inProgressData.shipDate, 'YYYY-MM-DD')
      .diff(date, 'days') < 0;
    const notBiggerThanThreeMonths = moment().diff(date, 'months') > -3;

    return biggerThanToday && notBiggerThanThreeMonths;
  }
}
